module.exports = __webpack_public_path__ + "img/tax-credit-invoice.fe18748b.svg";